import { ref, watch, computed } from 'vue';

const PROGRESS = {
	LOADING: 0,
	CASH_TRANSFER_REQUEST: 1,
	ORDER_DETAILS: 2,
	SUMMARY: 3,
	DOWNLOAD: 4,
	TECHNICAL_ERROR: 5
};
const EDIT_URL = '#';

const currentStep = ref(0);
const progress = ref(0);

watch(currentStep, (newVal) => {
	if (newVal > progress.value) {
		progress.value = newVal;
	}
});
const nextStep = () => {
	if (Object.values(PROGRESS).includes(currentStep.value + 1)) {
		currentStep.value++;
	}
};
const modify = (newStep) => {
	if (Object.values(PROGRESS).includes(newStep + 1)) {
		currentStep.value = newStep + 1;
	}
};
const retry = () => {
	currentStep.value = PROGRESS.CASH_TRANSFER_REQUEST;
};
const setTechnicalError = () => {
	currentStep.value = PROGRESS.TECHNICAL_ERROR;
};
const steps = computed(() => [
	{
		text: 'Készpénzátutalási megbízás',
		editUrl: progress.value > PROGRESS.CASH_TRANSFER_REQUEST ? EDIT_URL : null,
		current: currentStep.value == PROGRESS.CASH_TRANSFER_REQUEST,
		done: progress.value > PROGRESS.CASH_TRANSFER_REQUEST && currentStep.value != PROGRESS.CASH_TRANSFER_REQUEST
	},
	{
		text: 'Megrendelés adatok',
		editUrl: progress.value > PROGRESS.ORDER_DETAILS ? EDIT_URL : null,
		current: currentStep.value == PROGRESS.ORDER_DETAILS,
		done: progress.value > PROGRESS.ORDER_DETAILS && currentStep.value != PROGRESS.ORDER_DETAILS
	},
	{
		text: 'Ellenőrzés',
		current: currentStep.value == PROGRESS.SUMMARY,
		done: progress.value > PROGRESS.SUMMARY && currentStep.value != PROGRESS.SUMMARY
	},
	{
		text: 'Letöltés',
		current: currentStep.value == PROGRESS.DOWNLOAD,
		done: progress.value > PROGRESS.DOWNLOAD && currentStep.value != PROGRESS.DOWNLOAD
	}
]);

export const useProgress = () => {
	return {
		steps,
		currentStep,
		nextStep,
		modify,
		retry,
		setTechnicalError
	};
};
